export default {
  home: 'Acasă',
  menu: 'Meniu',
  orders: 'Comenzi',
};
